/**
 * DR Upsell Bundles – Independent Slots Controller
 * Index-based offer switching with touch swipe support.
 */
(function () {
  'use strict';

  var cached = {
    productFormElement: null,
    form: null,
    idInput: null,
    dotsResizeListenerBound: false,
    dotsResizeQueued: false,
  };
  var dotsLineUpdaters = [];

  function pruneDotsLineUpdaters() {
    dotsLineUpdaters = dotsLineUpdaters.filter(function (entry) {
      return entry && entry.root && entry.root.isConnected && typeof entry.update === 'function';
    });
  }

  function ensureDotsResizeListener() {
    if (cached.dotsResizeListenerBound) return;
    cached.dotsResizeListenerBound = true;

    window.addEventListener('resize', function () {
      if (cached.dotsResizeQueued) return;
      cached.dotsResizeQueued = true;

      window.requestAnimationFrame(function () {
        cached.dotsResizeQueued = false;
        pruneDotsLineUpdaters();
        dotsLineUpdaters.forEach(function (entry) {
          entry.update();
        });
      });
    });
  }

  function registerDotsLineUpdater(root, updateFn) {
    if (!root || typeof updateFn !== 'function') return;
    pruneDotsLineUpdaters();
    dotsLineUpdaters.push({ root: root, update: updateFn });
    ensureDotsResizeListener();
  }

  function cacheMainProductForm(productId) {
    if (cached.productFormElement) return;

    var productInfo = document.querySelector('product-info[data-product-id="' + productId + '"]');
    if (productInfo) {
      var pf = productInfo.querySelector('product-form');
      if (pf) {
        cached.productFormElement = pf;
        cached.form = pf.querySelector('form');
        if (cached.form) {
          cached.idInput = cached.form.querySelector('input[name="id"]');
        }
      }
    }

    if (!cached.productFormElement) {
      var pfFallback = document.querySelector('product-form');
      if (pfFallback) {
        cached.productFormElement = pfFallback;
        cached.form = pfFallback.querySelector('form');
        if (cached.form) {
          cached.idInput = cached.form.querySelector('input[name="id"]');
        }
      }
    }
  }

  function submitBundleViaProductForm(variantId, productId) {
    cacheMainProductForm(productId);
    if (!cached.form || !cached.idInput) return false;

    var previousId = cached.idInput.value;
    cached.idInput.value = String(variantId);

    if (typeof cached.form.requestSubmit === 'function') {
      cached.form.requestSubmit();
    } else {
      cached.form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }

    setTimeout(function () {
      cached.idInput.value = previousId;
    }, 0);

    return true;
  }

  function renderNickname(rawNickname, targetEl) {
    if (!targetEl) return;
    var text = rawNickname || '';
    text = text.replace(/&lt;br\s*\/?&gt;/gi, '<br>');
    text = text.replace(/\+/g, '<span class="dr-upsell-bundles__plus-inline">+</span>');
    targetEl.innerHTML = text;
  }

  function applyIntrinsicCutoutSizing(root) {
    if (!root) return;

    var images = Array.prototype.slice.call(root.querySelectorAll('.dr-upsell-bundles__card-image'));
    if (!images.length) return;

    var MAIN_TARGET_HEIGHT = 300;
    var SIDE_TO_MAIN_RATIO = 0.95;

    function isVisibleForSizing(img) {
      var slotCard = img.closest('.dr-upsell-bundles__slot-card');
      if (!slotCard) return true;
      return slotCard.classList.contains('is-active');
    }

    function getSourceHeight(img) {
      var wrap = img.closest('.dr-upsell-bundles__card-image-wrap');
      var raw = wrap ? Number(wrap.dataset.drSourceHeight) : 0;
      return raw > 0 ? raw : img.naturalHeight;
    }

    function recalc() {
      var visibleImages = images.filter(function (img) {
        return img && isVisibleForSizing(img);
      });

      if (!visibleImages.length) return;

      var loadedVisibleImages = visibleImages.filter(function (img) {
        return getSourceHeight(img) > 0;
      });

      if (!loadedVisibleImages.length) return;

      var activeMode = root.dataset.activeMode === 'duo'
        ? 'duo'
        : (root.dataset.upsellInitialMode === 'duo' ? 'duo' : 'trio');

      var tallestVisibleHeight = loadedVisibleImages.reduce(function (maxValue, img) {
        return Math.max(maxValue, getSourceHeight(img));
      }, 0);

      var referenceHeight = 0;

      var centerImage = loadedVisibleImages.find(function (img) {
        var card = img.closest('.dr-upsell-bundles__card');
        return !!(card && card.classList.contains('dr-upsell-bundles__card--main'));
      });

      referenceHeight = centerImage ? getSourceHeight(centerImage) : 0;
      if (!referenceHeight) {
        referenceHeight = tallestVisibleHeight;
      }

      if (!referenceHeight) return;

      loadedVisibleImages.forEach(function (img) {
        var card = img.closest('.dr-upsell-bundles__card');
        var isMain = !!(card && card.classList.contains('dr-upsell-bundles__card--main'));
        var multiplier = isMain ? 1 : SIDE_TO_MAIN_RATIO;
        var sourceHeight = getSourceHeight(img);
        
        var wrap = img.closest('.dr-upsell-bundles__card-image-wrap');
        var sourceWidth = wrap ? Number(wrap.dataset.drSourceWidth) : 0;
        if (!sourceWidth) sourceWidth = img.naturalWidth || 1;
        
        var aspectRatio = sourceWidth / sourceHeight;
        var targetHeight = (sourceHeight / referenceHeight) * MAIN_TARGET_HEIGHT * multiplier;
        
        // 1. Boost tiny items (e.g. jars) so they don't disappear next to tall bottles
        var MIN_HEIGHT = 130;
        if (targetHeight < MIN_HEIGHT) {
          targetHeight = MIN_HEIGHT;
        }
        
        // 2. Cap max height to prevent side products from towering over a short main product
        var MAX_HEIGHT = isMain ? MAIN_TARGET_HEIGHT : MAIN_TARGET_HEIGHT * multiplier;
        if (targetHeight > MAX_HEIGHT) {
          targetHeight = MAX_HEIGHT;
        }
        
        // 3. Constrain by max width so square products don't bleed out of the glass card
        var MAX_WIDTH = isMain ? 155 : 145;
        var projectedWidth = targetHeight * aspectRatio;
        
        if (projectedWidth > MAX_WIDTH) {
          targetHeight = MAX_WIDTH / aspectRatio;
        }
        
        img.style.height = targetHeight.toFixed(2) + 'px';
      });

      root.classList.add('is-cutout-sized');
    }

    images.forEach(function (img) {
      if (img.dataset.drIntrinsicSizingBound === '1') return;
      img.dataset.drIntrinsicSizingBound = '1';
      img.addEventListener('load', recalc);
    });

    recalc();
    return recalc;
  }

  function initUpsell(root) {
    if (!root || root.dataset.initialized === '1') return;
    root.dataset.initialized = '1';

    var productId = root.dataset.productId;

    var unifiedStage = root.querySelector('[data-upsell-stage]');
    if (!unifiedStage) return;

    var leftSlot = root.querySelector('[data-upsell-left-slot]');
    var rightSlot = root.querySelector('[data-upsell-right-slot]');
    var duoSlot = root.querySelector('[data-upsell-duo-slot]');
    var offerDataWrap = root.querySelector('[data-upsell-offer-data]');

    var leftCards = leftSlot
      ? Array.prototype.slice.call(leftSlot.querySelectorAll('[data-offer-index]'))
      : [];
    var rightCards = rightSlot
      ? Array.prototype.slice.call(rightSlot.querySelectorAll('[data-offer-index]'))
      : [];
    var duoCards = duoSlot
      ? Array.prototype.slice.call(duoSlot.querySelectorAll('[data-offer-index]'))
      : [];
    var offers = offerDataWrap
      ? Array.prototype.slice.call(offerDataWrap.querySelectorAll('[data-upsell-offer]'))
      : [];

    if (!offers.length) return;

    var recalcCutoutSizing = applyIntrinsicCutoutSizing(root);

    var dotsContainer = root.querySelector('[data-upsell-dots]');
    var dots = dotsContainer
      ? Array.prototype.slice.call(dotsContainer.querySelectorAll('[data-upsell-dot]'))
      : [];
    var pillsContainer = root.querySelector('[data-upsell-pills]');
    var pills = pillsContainer
      ? Array.prototype.slice.call(pillsContainer.querySelectorAll('[data-upsell-pill]'))
      : [];

    var cta = root.querySelector('[data-upsell-cta]');
    var summary = root.querySelector('[data-upsell-summary]');
    var nicknameEl = summary ? summary.querySelector('[data-upsell-summary-nickname]') : null;
    var nameEl = summary ? summary.querySelector('[data-upsell-summary-name]') : null;
    var taglineEl = summary ? summary.querySelector('[data-upsell-summary-tagline]') : null;
    var pricesEl = summary ? summary.querySelector('[data-upsell-summary-prices]') : null;
    var regularEl = summary ? summary.querySelector('[data-upsell-summary-regular]') : null;
    var couponEl = summary ? summary.querySelector('[data-upsell-summary-coupon]') : null;
    var unitEl = summary ? summary.querySelector('[data-upsell-summary-unit]') : null;

    var activeIndex = 0;
    var offerCount = offers.length;

    function getOfferMode(offer) {
      if (!offer) return 'trio';
      return offer.getAttribute('data-upsell-mode') === 'duo' ? 'duo' : 'trio';
    }

    function applyModeForOffer(offer) {
      var mode = getOfferMode(offer);
      root.classList.toggle('is-mode-duo', mode === 'duo');
      root.classList.toggle('is-mode-trio', mode !== 'duo');
      root.dataset.activeMode = mode;
    }

    function setActiveIndex(index) {
      if (index < 0 || index >= offerCount || index === activeIndex) return;

      activeIndex = index;

      leftCards.forEach(function (card) {
        card.classList.toggle('is-active', Number(card.dataset.offerIndex) === activeIndex);
      });

      rightCards.forEach(function (card) {
        card.classList.toggle('is-active', Number(card.dataset.offerIndex) === activeIndex);
      });

      duoCards.forEach(function (card) {
        card.classList.toggle('is-active', Number(card.dataset.offerIndex) === activeIndex);
      });

      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === activeIndex);
        dot.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
      });
      pills.forEach(function (pill, i) {
        pill.classList.toggle('is-active', i === activeIndex);
        pill.setAttribute('aria-selected', i === activeIndex ? 'true' : 'false');
      });

      root.dataset.activeIndex = String(activeIndex);

      applyModeForOffer(offers[activeIndex]);
      updateSummary(offers[activeIndex]);
      if (recalcCutoutSizing) recalcCutoutSizing();
    }

    function updateSummary(offer) {
      if (!offer || !summary) return;

      var nickname = offer.getAttribute('data-summary-nickname') || '';
      var name = offer.getAttribute('data-summary-name') || '';
      var tagline = offer.getAttribute('data-summary-tagline') || '';
      var regular = offer.getAttribute('data-summary-regular') || '';
      var coupon = offer.getAttribute('data-summary-coupon') || '';
      var unit = offer.getAttribute('data-summary-unit') || '';

      renderNickname(nickname, nicknameEl);
      if (nameEl) nameEl.textContent = name;

      if (taglineEl) {
        taglineEl.textContent = tagline;
        taglineEl.style.display = tagline ? '' : 'none';
      }

      if (regularEl) regularEl.textContent = regular;
      if (couponEl) couponEl.textContent = coupon;
      if (unitEl) unitEl.textContent = unit;
      if (pricesEl) {
        pricesEl.style.display = regular || coupon || unit ? '' : 'none';
      }

      if (window.drCardCouponPill && typeof window.drCardCouponPill.refresh === 'function') {
        window.drCardCouponPill.refresh();
      }

      summary.classList.remove('is-updating');
      window.requestAnimationFrame(function () {
        summary.classList.add('is-updating');
      });
    }

    function updateDotsLine() {
      if (!dots.length || !dotsContainer) return;

      if (dots.length === 1) {
        dotsContainer.style.setProperty('--dots-line-width', '0px');
        dotsContainer.style.setProperty('--dots-line-left', '50%');
      } else {
        var first = dots[0];
        var last = dots[dots.length - 1];

        var firstRect = first.getBoundingClientRect();
        var lastRect = last.getBoundingClientRect();
        var containerRect = dotsContainer.getBoundingClientRect();

        var firstCenter = firstRect.left + firstRect.width / 2;
        var lastCenter = lastRect.left + lastRect.width / 2;

        var leftCenter = Math.min(firstCenter, lastCenter);
        var rightCenter = Math.max(firstCenter, lastCenter);

        var width = Math.max(0, rightCenter - leftCenter);
        var left = leftCenter - containerRect.left;

        dotsContainer.style.setProperty('--dots-line-width', width + 'px');
        dotsContainer.style.setProperty('--dots-line-left', left + 'px');
      }

      dotsContainer.classList.add('dr-upsell-bundles__dots--ready');
    }

    /* Touch swipe on stage (RTL-aware) */
    var touchStartX = 0;
    var touchStartY = 0;
    var SWIPE_THRESHOLD = 30;

    function bindStageSwipe(stageEl) {
      if (!stageEl) return;

      stageEl.addEventListener('touchstart', function (e) {
        touchStartX = e.changedTouches[0].clientX;
        touchStartY = e.changedTouches[0].clientY;
      }, { passive: true });

      stageEl.addEventListener('touchend', function (e) {
        var deltaX = e.changedTouches[0].clientX - touchStartX;
        var deltaY = e.changedTouches[0].clientY - touchStartY;

        if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaY) > Math.abs(deltaX)) return;

        // RTL: swipe right (positive deltaX) = next, swipe left = prev
        if (deltaX > 0) {
          setActiveIndex(activeIndex + 1);
        } else {
          setActiveIndex(activeIndex - 1);
        }
      }, { passive: true });
    }

    bindStageSwipe(unifiedStage);

    /* Dots */
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        setActiveIndex(index);
      });
    });

    /* Pills */
    pills.forEach(function (pill, index) {
      pill.addEventListener('click', function () {
        setActiveIndex(index);
      });
    });

    /* Resize (shared listener across all upsell instances) */
    registerDotsLineUpdater(root, updateDotsLine);

    /* CTA */
    if (cta) {
      cta.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();

        var offer = offers[activeIndex];
        if (!offer) return;

        var variantId = offer.getAttribute('data-upsell-variant-id');
        if (!variantId) return;

        var spinner = cta.querySelector('.loading__spinner');
        cta.setAttribute('aria-disabled', 'true');
        cta.classList.add('loading');
        cta.disabled = true;
        if (spinner) spinner.classList.remove('hidden');

        var ok = submitBundleViaProductForm(variantId, productId);

        window.setTimeout(
          function () {
            cta.classList.remove('loading');
            cta.removeAttribute('aria-disabled');
            cta.disabled = false;
            if (spinner) spinner.classList.add('hidden');
          },
          ok ? 1200 : 300
        );
      });
    }

    /* Initial state */
    applyModeForOffer(offers[0]);
    updateSummary(offers[0]);
    updateDotsLine();
  }

  function initAllUpsellBundles(context) {
    var ctx = context || document;
    var roots = ctx.querySelectorAll('[data-upsell-root]');
    roots.forEach(initUpsell);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllUpsellBundles(document);
    });
  } else {
    initAllUpsellBundles(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    cached.productFormElement = null;
    cached.form = null;
    cached.idInput = null;

    if (event.target) {
      initAllUpsellBundles(event.target);
    }
  });
})();
